import type { UserContext } from '../services/portal';

/**
 * The server context is the onboarding authority. Only an incomplete learner
 * enters the first-run flow; staff and an unavailable context fail open so a
 * context outage cannot trap every authenticated user in onboarding.
 */
export function shouldRequireOnboarding(
  context: Pick<UserContext, 'role' | 'onboarding_complete'> | null,
  hasCourseTesterGrant = false,
): boolean {
  // An approved course tester does not own the program the first-run path
  // assumes. Expired/revoked testers also need an honest access state, not a
  // fabricated first lecture. This is navigation only, never authorization.
  return context?.role === 'student' && !context.onboarding_complete && !hasCourseTesterGrant;
}
